export default __webpack_public_path__ + "static/media/thienxa.f5728548.png";